// extracted by mini-css-extract-plugin
export default {"notification":"footer_notification__biGCN"};